import { Direction, clone } from "@gemma/utils";
import { ResolvedQueryOptions, Sort } from "@gemma/querying";

import { ISortOptions } from "./ISortOptions";
import { IThisResolveSortingFields } from "./IThisResolveSortingFields";
import { IVue } from "../../app/mixins/IVue";
import { Nullable } from "@gemma/typescript-types";
import { loadGroupedQueryOptions } from "@timesheets/webapp-support";
import { pageSizes } from "./pageSizes";

export async function resolveSortingFields<TFilter>(this: IVue & IThisResolveSortingFields<TFilter> & { groupedQueryOptionsId: string }, setQueryOptions: (queryOptions: ResolvedQueryOptions<TFilter>) => void): Promise<void> {
  if (Array.isArray(this.sorting.fields)) {
    if (this.sorting.fields.length > 0) {
      if (typeof (this.sorting.fields as string[])[0] === "string") {
        const stringFields = this.sorting.fields as string[];
        const fields: Record<string, ISortOptions> = (this.sorting.fields = {});
        for (const fieldName of stringFields) {
          fields[fieldName] = { direction: Direction.Forward };
        }
      }

      if (!this.sorting.current) {
        if (this.defaultSort.length > 0) {
          const defaultFieldKeys = Object.keys(this.defaultSort[0]);
          if (defaultFieldKeys[0].length > 0) {
            this.sorting.current = defaultFieldKeys[0];
            this.sort = this.defaultSort.reduce<Sort>((acc, curr) => {
              const { key, newKey } = getSortNames(curr);
              acc.push([newKey, curr[key]]);
              return acc;
            }, []);
          }
        }
      }
    } else {
      this.sorting.fields = {};
    }
  }

  const data = await loadGroupedQueryOptions(this.$app.api, this.currentRole, this.groupedQueryOptionsId);
  if (data) {
    const queryOptions_ = clone(this.queryOptions);
    const pageSize = pageSizes.find(pageSize => data.page.size === +pageSize.id) || pageSizes[2];
    queryOptions_.filter = data.filter as TFilter;
    queryOptions_.groupBy = this.queryOptions.groupBy || null;
    queryOptions_.page = Object.assign(data.page, { size: +pageSize.id });
    queryOptions_.search = this.queryOptions.search || null;
    queryOptions_.sort = data.sort || this.queryOptions.sort || [];

    setQueryOptions(queryOptions_);
  }

  let current: Nullable<string> = null;
  const fieldKeys = Object.keys(this.sorting.fields as Record<string, ISortOptions>);
  if (data && data.sort[0]) {
    const savedCurrent = data.sort[0][0].replaceAll(".", "_");
    if (fieldKeys.some(key => key === savedCurrent)) {
      current = savedCurrent;
    }
  }

  if (!current && this.defaultSort.length > 0) {
    const defaultFieldKeys = Object.keys(this.defaultSort[0]);
    if (defaultFieldKeys[0].length > 0) {
      current = defaultFieldKeys[0];
      this.sort = this.defaultSort.reduce<Sort>((acc, curr) => {
        const { key, newKey } = getSortNames(curr);
        acc.push([newKey, curr[key]]);
        return acc;
      }, []);
    }
  }

  if (!current) {
    current = fieldKeys[0];
    this.sort = this.defaultSort.reduce<Sort>((acc, curr) => {
      const { key, newKey } = getSortNames(curr);
      acc.push([newKey, curr[key]]);
      return acc;
    }, []);
  }

  this.sorting.current = current;
}

function getSortNames(currentSort: Record<string, Direction>) {
  const key = Object.keys(currentSort)[0];
  const newKey = key.replaceAll("_", ".");

  return {
    key,
    newKey,
  };
}
